import React from 'react';
import { Input, Textarea, Select, Button, PaperClip, DatePicker } from 'components';
import { ProfileService, AuthService } from 'services';
import moment from 'moment';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { Globals, Constants, Socket, SocketEvents } from 'utils';
import { RouteComponentProps } from 'react-router-dom';
import { Menu as MenuIcons, CopyIcon, PhoneIcon, WebIcon, InstagramIcon, FacebookIcon, LocationIcon, TimeIcon, AddIcon, TrashIcon, CodingIcon, UserIcon } from 'assets/icons';
import { WhiteImage } from 'assets/img';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

class Profile extends React.Component<Props> {

	state = {
		form: {
			name: '',
			lastname: '',
			email: '',
	        password: '',
	        password_confirmation: '',
		},
		user: null
	}

	componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Mi Cuenta',
				onBack: null,
				subtitle: 'Consulta y administra la información del perfil del usuario.',
				color: '#edf0fe',
				icon: MenuIcons.Menu3
			}
		});

		this.load();
	}

	load = async (withoutLoading = false) => {
		const res: any = await ProfileService.get({
			withoutLoading
		});
		this.setState({
			user: res.user,
			form: {
				...this.state.form,
				name: res.user?.name || '',
				lastname: res.user?.lastname || '',
				email: res.user?.email || ''
			},
			bearer_token: res.user?.bearer_token || ''
		});
	}

	submit = async (e: any) => {
		e.preventDefault();
		const res: any = await ProfileService.update({
			...this.state.form,
			hasFile: true
		});
		Globals.showSuccess("Se ha actualizado el perfil correctamente");
		this.props.dispatch({
			type: 'SET_USER',
			payload: res.user
		});
		this.setState({
			form: {
				...this.state.form,
				password: '',
        		password_confirmation: '',
			}
		});
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	closeAllSession = () => {
		Globals.confirm('¿Desea cerrar sesión en todos los dispositivos (a excepción de este)?',async () => {
			const res: any = await AuthService.closeAllSessions();
			if (res.user) {
				this.props.dispatch({
					type: 'SET_USER',
					payload: res.user
				});
				Globals.showSuccess("Se ha cerrado las sesiones correctamente");
				Socket.emit(SocketEvents.UPDATE_USER,{
					user_id: res.user?.id
				});
			}
		});
	}
	
	render() {
		return (
			<div id="profile">
				<form className="row" onSubmit={ this.submit }>	
					<div className="col-md-12">
						<div className="container-form">
							<div className="row">
								<div className="col-md-6">
									<Input
										color="white"
										value={ this.state.form.name }
										name="name" 
										label="Nombre"
										onChange={ this.change } />
								</div>
								<div className="col-md-6">
									<Input
										color="white"
										value={ this.state.form.lastname }
										name="lastname" 
										label="Apellido"
										onChange={ this.change } />
								</div>
								<div className="col-md-6">
									<Input
										color="white"
										value={ this.state.form.email }
										name="email" 
										label="Correo Electrónico"
										onChange={ this.change } />
								</div>
								<div className="col-md-6">
									<Input
										type="password"
										color="white"
										value={ this.state.form.password }
										name="password" 
										label="Cambiar contraseña (Opcional)"
										placeholder="Contraseña"
										onChange={ this.change } />
								</div>
								<div className="col-md-6">
									<Input
										type="password"
										color="white"
										value={ this.state.form.password_confirmation }
										name="password_confirmation" 
										label="Repetir contraseña"
										placeholder="Contraseña"
										onChange={ this.change } />
								</div>
								<div className="col-12 text-center">
									<Button type="submit">
										Guardar
									</Button>													
								</div>
							</div>
						</div>
					</div>
				</form>

				<div className="text-center">
					<button className="btn close-all-sessions" onClick={ () => this.closeAllSession() }>
						Cerrar sesión en todos los dispositivos
					</button>
				</div>
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(Profile);